import { cx } from '@mage-ui/styled-system/css';
import { gridRow } from '@mage-ui/styled-system/recipes';

export const GridRow = ({ children, className, ...props }) => {
  return (
    <div className={cx(gridRow(), className)} {...props}>
      {children}
    </div>
  );
};
